<template>
  <!-- SP Slide menu -->
  <div id="spslidemenu"><div class="spslidemenu_close"></div>
    <div class="spslidemenu_inner">
      <h2>CONTENTS</h2>
      <ul id="spslidemenu1">
        <li class="home_spmenu01"><a :href="`${mypageRootPath}/maintenanceinfo/`" target="_self" class="need-login">Myぺージ</a></li>
	<li class="home_spmenu02"><a href="https://www.misawa.co.jp/ownersclub/yutai/" target="_self" class="need-login">オーナーさま限定優待</a></li>
        <li class="home_spmenu03"><a href="https://life.misawa.co.jp/link.php" target="_self" class="need-login">公式通販らいさぽWeb</a></li>
        <li class="home_spmenu04"><a :href="`${mypageRootPath}/../maintenance/main/`" target="_self">お手入れ・メンテナンス</a></li>
        <li class="home_spmenu05"><a :href="`${mypageRootPath}/../column/`" target="_self" class="need-login">くらしのコラム</a></li>
        <li class="home_spmenu06"><a :href="`${mypageRootPath}/../reform`" target="_self">リフォームしたい</a></li>
        <li class="home_spmenu07"><a href="http://www.misawa.co.jp/ownersclub/fudosan_support/index.html" target="_self">売りたい・貸したい</a></li>
        <li class="home_spmenu08"><a href="https://www.misawa.co.jp/ownersclub/kakusyu/index.html" target="_self">各種ご相談・お問い合わせ</a></li>
      </ul>
      <ul class="spslidemenu2">
        <li><a href="https://www.misawa.co.jp/ownersclub/kakusyu/index.html" target="_blank">住まいるりんぐDesk（お客様相談窓口）</a></li>
        <li><a href="https://www.misawa.co.jp/otikaku/index.html" target="_blank">お近くのミサワホーム</a></li>
        <li><a href="https://www.misawa.co.jp/ownersclub/kakusyu/index.html" target="_blank">カタログ請求</a></li>
        <li><a href="http://www.misawa.co.jp/misawa/kigyou/index.html">企業情報</a></li>
        <li v-if="!noLogin"><a :href="changeInfoUrl" @click.prevent="clickChangeInfoUrl">{{ isMgGroupMember ? '社員' : '会員' }}情報の変更</a></li>
        <li v-if="!noLogin"><a :href="`${mypageRootPath}/../logout.jsp`" target="_self">ログアウト</a></li>
      </ul>
<!--      <ul class="spslidemenu2">-->
<!--        <li><a href="http://www.misawa.co.jp/corporate/news_release/index.html">ニュースリリース</a></li>-->
<!--        <li><a href="http://www.misawa.co.jp/misawa/kigyou/index.html">企業情報</a></li>-->
<!--        <li><a href="http://www.misawa.co.jp/misawa/ir/index.html">IR情報</a></li>-->
<!--        <li><a href="http://www.misawa.co.jp/misawa/csr/index.html">CSR報告書</a></li>-->
<!--        <li><a href="http://www.misawa.co.jp/misawa/recruit/index.html">リクルート情報</a></li>-->
<!--        <li><a href="http://www.misawa.co.jp/en/info/">English</a></li>-->
<!--      </ul>-->
<!--      <ul class="spslidemenu2">-->
<!--        <li><a href="http://www.misawa.co.jp/legal/site.html">このサイトについて</a></li>-->
<!--        <li><a href="http://www.misawa.co.jp/legal/privacy.html">プライバシーポリシー</a></li>-->
<!--        <li><a href="https://www.misawa.co.jp/legal/tokumei_kakou.html">匿名加工情報の取扱いについて</a></li>-->
<!--      </ul>-->
    </div>
  </div>
</template>

<script>
import Common from './Common.js'

export default {
  name: 'moc-sp-slide-menu',

  mixins: [ Common ]
}
</script>



// WEBPACK FOOTER //
// src/components/MocSpSlideMenu.vue